<template>
  <tr v-if="curItem">
    <td>
      <input-number 
        v-model="curItem.quantity"
        :min="1"
      />
    </td>
    <td>
      <input-text 
        v-model="curItem.hrCode"
        :placeholder="'XXXX.XX'"
      />
    </td>
    <td>
      <input-text 
        v-model="curItem.description"
      />
    </td>
    <td>
      <input-number 
        v-model="curItem.weight"
        :min="0"
      />
    </td>
    <td>
      <input-text
        :placeholder="formatPrice(0)"
        :value="curItem.value ? formatPrice(curItem.value) : ''"
        @blur="e => processPriceValue(e)"
      />
    </td>
    <td>
      <country-dropdown
        v-model="selectedCountry"
        :countryList="countryList"
        :startVal="selectedCountry"
        :showLabel="false"
        @input="curItem.originCountry = selectedCountry.code"
      />
    </td>
    <td>
      <input-text 
        :placeholder="formatPrice(0)"
        :class="'disabled'"
      />
    </td>
  </tr>
  <tr v-else></tr>
</template>

<script>
import { mapGetters } from 'vuex';
import {FormatPrice} from '@/utils/general-data';
import {ProcessInputValue} from '@/utils/input';
import InputText from '@/components/InputText';
import InputNumber from '@/components/InputNumber';
import CountryDropdown from '@/components/CountryDropdown';

export default {
  name: 'customs-item',
  components: {
    'input-text': InputText,
    'input-number': InputNumber,
    'country-dropdown': CountryDropdown,
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedCountry: {},
      curItem: null,
      noUpdate: true
    }
  },
  computed: {
    ...mapGetters({
      countryList: 'countryList',
      provider: 'provider'
    })
  },
  created() {
    this.selectedCountry = this.countryList.find(country => country.id == this.provider.country_id);
    this.curItem = Object.assign({}, this.item);
    this.noUpdate = false;
  },
  methods: {
    formatPrice: FormatPrice,
    processPriceValue(e) {
      this.curItem.value = ProcessInputValue(e, 'price');
    },
  },
  watch: {
    curItem: {
      deep: true,
      handler(val) {
        if (!this.noUpdate) {
          this.$emit('update', val);
        }
      }
    }
  }
}
</script>